// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_3 from '/opt/buildhome/repo/src/models/global';
import model_4 from '/opt/buildhome/repo/src/models/regions';
import model_5 from '/opt/buildhome/repo/src/.umi-production/plugin-initialState/@@initialState';
import model_1 from '/opt/buildhome/repo/src/models/carriers';
import model_2 from '/opt/buildhome/repo/src/models/dicts';

export const models = {
model_3: { namespace: 'global', model: model_3 },
model_4: { namespace: 'regions', model: model_4 },
model_5: { namespace: '@@initialState', model: model_5 },
model_1: { namespace: 'carriers', model: model_1 },
model_2: { namespace: 'dicts', model: model_2 },
} as const
